export enum Pathname {
  BoardByBoardId = '/b/[boardId]',
  BoardClip = '/b/[boardId]/c/[clipId]',
  BoardCanvas = '/b/[boardId]/canvas/[canvasId]',
  LibraryGeneral = '/l/general',
  LibraryByLibraryId = '/l/[libraryId]',
  SavedSearch = '/saved-search',
  SavedSearchBySavedSearchId = '/saved-search/[savedSearchId]',
  Search = '/all',
}
